<template>
  <div
    v-if="retributionsBoostEnabled()"
    class="mb-6 grid gap-4 overflow-x-auto pb-2"
    :style="{ gridTemplateColumns: `repeat(${tiers.length}, minmax(0, 1fr))` }"
  >
    <div
      v-for="tier in tiers"
      :key="tier.key"
      @click="handleTierUpdate(tier.key)"
      :class="[
        'shrink-0 rounded-lg p-4 cursor-pointer transition-all border',
        isCurrentlySelected(tier)
          ? 'bg-green-50 text-green-600 border-green-300 shadow-lg'
          : 'bg-white text-black border-gray-200 hover:border-gray-300',
      ]"
    >
      <div class="flex flex-col items-center text-center">
        <div :class="['font-bold text-lg mb-1', isCurrentlySelected(tier) ? 'text-green-600' : 'text-black']">
          {{ tier.label }}
        </div>
        <div :class="['text-sm', isCurrentlySelected(tier) ? 'text-green-600' : 'text-gray-600']">
          {{ tier.description }}
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { boosterThresholds } from "@/utils/booster";
import { mapGetters } from "vuex";

export default {
  props: {
    modelValue: {
      type: String,
      default: "none",
    },
  },

  data() {
    return {
      boosterThresholds,
    };
  },

  computed: {
    ...mapGetters("store", ["retributionsBoostEnabled"]),

    tiers() {
      const sortedThresholds = [...this.boosterThresholds].sort((a, b) => a.threshold - b.threshold);

      const defaultThreshold = sortedThresholds[0]?.threshold || 30;

      const baseTier = {
        key: "none",
        label: "Aucun palier",
        description: `Moins de ${defaultThreshold} ventes`,
        multiplicator: 0,
      };

      const dynamicTiers = sortedThresholds.map((threshold, index) => {
        const next = sortedThresholds[index + 1];
        const description = next
          ? `entre ${threshold.threshold} et ${next.threshold - 1} ventes`
          : `plus de ${threshold.threshold} ventes`;

        return {
          key: threshold.tier,
          label: `Palier ${threshold.tier}`,
          description,
          multiplicator: threshold.multiplicator,
          threshold: threshold.threshold,
        };
      });

      return [baseTier, ...dynamicTiers];
    },

    isCurrentlySelected() {
      return (tier) => {
        return this.modelValue === tier.key;
      };
    },
  },

  methods: {
    handleTierUpdate(tierKey) {
      this.$emit("update:modelValue", tierKey);
    },
  },
};
</script>
